import React from 'react';

// Exibe "carregando" / erro enquanto o índice de documentos não está pronto
function Carregando({ carregando, erro, children }) {
    if (carregando) {
        return <p className="estado" role="status">Carregando documentos…</p>;
    }
    if (erro) {
        return (
            <p className="estado estado--erro" role="alert">
                Não foi possível carregar a lista de documentos. Atualize a página ou tente novamente em instantes.
            </p>
        );
    }
    return children;
}

export default Carregando;
